import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import TableSortLabel from '@material-ui/core/TableSortLabel';

class MatTableHead extends PureComponent {
  static propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    t: PropTypes.func.isRequired
  };

  createSortHandler = property => (event) => {
    const { onRequestSort } = this.props;
    onRequestSort(event, property);
  };

  render() {
    const {
      onSelectAllClick, order, orderBy, numSelected, rowCount, notOK, t
    } = this.props;

    let rows = [
      {id: 'status', disablePadding: true, label: t('forms.status')},
      {id: 'name', disablePadding: false, label: t('forms.name')},
      {id: 'email', disablePadding: false, label: t('forms.email')},
      {id: 'phone', disablePadding: false, label: t('forms.phone')},
      {id: 'createdAt', disablePadding: false, label: t('forms.createdAt')}, 
      {id: 'updatedAt', disablePadding: false, label: t('forms.updatedAt')} 
    ];
    
    let check = "";
    if(!notOK){
      check = <TableCell padding="checkbox">
                <Checkbox
                  className={`material-table__checkbox ${numSelected === rowCount && 'material-table__checkbox--checked'}`}
                  indeterminate={numSelected > 0 && numSelected < rowCount}
                  checked={numSelected === rowCount}
                  onChange={onSelectAllClick}
                />
              </TableCell>
    }

    return (
      <TableHead>
        <TableRow>
          {check}
          {rows.map(row => (
            <TableCell
              className="material-table__cell material-table__cell--sort material-table__cell-right"
              key={row.id}
              align={'left'}
              padding={row.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === row.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === row.id}
                direction={order}
                onClick={this.createSortHandler(row.id)}
                className="material-table__sort-label"
                dir="ltr"
              >
                {row.label}
              </TableSortLabel>
            </TableCell>
          ), this)}
        </TableRow>
      </TableHead>
    );
  }
}

export default withTranslation('common')(MatTableHead);